<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs v-model="model" :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
      ">
      <v-tab :href="`#tab-1`" class="pl-0 ml-0">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Manager Commission History
      </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <WalletTransaction></WalletTransaction>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import WalletTransaction from "@/components/MamWallet/WalletTransaction.vue";
export default {
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    WalletTransaction,
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
  },
};
</script>
